import { render, staticRenderFns } from "./ShopUserReportRecord.vue?vue&type=template&id=20f94abd&scoped=true"
import script from "./ShopUserReportRecord.vue?vue&type=script&lang=js"
export * from "./ShopUserReportRecord.vue?vue&type=script&lang=js"
import style0 from "./ShopUserReportRecord.vue?vue&type=style&index=0&id=20f94abd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f94abd",
  null
  
)

export default component.exports